import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VAR_USER_TOKEN } from "../../../config/constants";

type AuthState = {
  message: string;
  payload: string;
};

const slice = createSlice({
  name: "auth",
  initialState: {
    payload: ""
  } as AuthState,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { payload }
      }: PayloadAction<{
        payload: string;
      }>
    ) => {
      state.payload = payload;
      localStorage.setItem(VAR_USER_TOKEN, payload);
    },

    setResetPasswordToken: (
      state,
      { payload: { payload } }: PayloadAction<{ payload: string }>
    ) => {
      state.payload = payload;
    },
    removeCredentials: (state) => {
      state.payload = "";
      localStorage.clear();
    }
  }
});

export const { setCredentials, removeCredentials, setResetPasswordToken } =
  slice.actions;
export default slice.reducer;
